import React from "react";
import { Outlet, Navigate } from "react-router-dom";


const Error404 = React.lazy(() => import("../components/errors/error404"));

function SampleReportPdfPreviewLayout() {
  /**
* Data retrieved from the Redux store for token role
* @type {any}
*/
  const isLogin = localStorage.getItem("admin_token") || null;

  return (
    <>
      {isLogin ? (<div className="d-flex flex-column min-vh-100 grey_bgs" >
        <Outlet />
      </div>) : (!isLogin ? (<Navigate to={"/login"} replace />) : (<Error404 />))}
    </>
  );
}

export default SampleReportPdfPreviewLayout;
